import * as THREE from "three";
const scene = new THREE.Scene();
export default scene;